import { getFileBlob } from "utils"

export const mapContactToEditContactForm = (contact = {}) => ({
  notes: contact?.notes,
  name: contact?.full_name,
  email: contact?.email,
  public: contact?.public,
  displayName: contact?.display_name,
  displayEmail: contact?.display_email,
  phone: contact?.phone,
  gender: contact?.gender,
  birthday: contact?.birthday,
  title: contact?.title,
  company: contact?.company,
  bio: contact?.bio,
  hobbies: contact?.interests,
  facebook: contact?.fb_link,
  instagram: contact?.insta_link,
  linkedin: contact?.linkedin_link,
  pinterest: contact?.pinterest_link,
  twitter: contact?.tw_link,
  youtube: contact?.yt_link,
  tiktok: contact?.tiktok_link,
  profile_pic: { editedImage: contact?.profile_pic?.file?.url },
  tags: contact?.userMetaTags?.map(tag => tag?.id),
})

export const mapEditContactFormToApi = (contact = {}) => ({
  email: contact?.email,
  display_name: contact?.displayName,
  display_email: contact?.displayEmail,
  gender: contact?.gender,
  birthday: contact?.birthday,
  title: contact?.title,
  company: contact?.company,
  bio: contact?.bio,
  interests: contact?.hobbies,
  fb_link: contact?.facebook,
  pinterest_link: contact?.pinterest,
  insta_link: contact?.instagram,
  linkedin_link: contact?.linkedin,
  tw_link: contact?.twitter,
  yt_link: contact?.youtube,
  tiktok_link: contact?.tiktok,
  notes: contact?.notes,
  public: contact?.public ? 1 : 0,
  phone: contact?.phone,
  profile_pic:
    contact?.profile_pic &&
    contact?.profile_pic?.editedImage &&
    getFileBlob(contact?.profile_pic?.editedImage),
  ...(contact?.delete_file ? { delete_file: 1 } : {}),
})

export const verifyLink = value =>
  value &&
  !/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/i.test(
    value
  )
    ? "The link is invalid! It must include both http:// or https:// and a suffix like .com"
    : undefined

const SSN_CLIENT_ID = 244

export const shouldDisplaySSN = vendor_id => vendor_id == SSN_CLIENT_ID
